import { useContext, computed, defineComponent, useCssModule } from '@nuxtjs/composition-api';
import { DEFAULT_BUSINESS_METRICS_OPTIONS } from '~/components/AboutBusinessMetrics/index';
export default defineComponent({
    name: 'AboutBusinessMetrics',
    props: {
        data: {
            default: () => [],
            type: Array,
        },
        options: {
            default: () => ({}),
            type: Object,
        },
    },
    setup(props) {
        /**
         * CSS Modules.
         */
        const css = useCssModule();
        const context = useContext();
        const viewport = context.$viewport;
        const currentOptions = computed(() => {
            const options = { ...DEFAULT_BUSINESS_METRICS_OPTIONS, ...props.options };
            return options[viewport.breakpoint] || options.tablet;
        });
        return {
            css,
            currentOptions,
        };
    },
});
